import { IApprovalProccessId } from "../../../types"
import { getApprovalActorAccess } from "../../shared/utils/approvalAccess"

interface IAssetEditAccess {
  isApprover: boolean
  isPic: boolean
  canEdit: boolean
}

export const getAssetEditAccess = (
  approvalProcess: IApprovalProccessId | null | undefined,
  employeeId: string | null | undefined,
): IAssetEditAccess => {
  const approvalAccess = getApprovalActorAccess(approvalProcess, employeeId)

  return {
    isApprover: approvalAccess.isApprover,
    isPic: approvalAccess.isPic,
    canEdit: approvalAccess.isApprover || approvalAccess.isPic,
  }
}
